import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cloud",
  "use": "icon-cloud-usage",
  "viewBox": "0 0 14 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 10\" id=\"icon-cloud\"><path d=\"M11.28 3.14a4.666 4.666 0 0 0-8.907 1.267A2.667 2.667 0 0 0 3 9.667h7.333a3.334 3.334 0 0 0 .947-6.527Zm-.947 5.193H3a1.333 1.333 0 1 1 0-2.666A.667.667 0 0 0 3.667 5a3.333 3.333 0 0 1 6.486-1.073.667.667 0 0 0 .52.44 2 2 0 0 1-.34 3.966Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol